import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import webhookIcon from '../../assets/images/icons/webhook-icon.png'
import videoClip from '../../assets/images/icons/video-clip.png'
import { useActions } from 'src/actions'
import { useNavigate } from 'react-router-dom'
import ListIntegrations from '../molecules/listIntegrations/listIntegrations'

const CreateNewRouter: React.FC<{
  show: boolean
  setShow: any
  onSubmit?: any
  description: string
  isNewRouter?: boolean
  isNewSLA?: boolean
}> = (props) => {
  const { show, setShow, description, isNewRouter, isNewSLA } = props
  const { registernewRoute, addSLAAction } = useActions()
  const [loading, setLoading] = useState(false)
  const navigation = useNavigate()

  const addRouter = async () => {
    setLoading(true)
    const result: any = await registernewRoute({})

    if (result.payload) {
      const routerId = result.payload._id
      navigation(`/routers/${routerId}/triggers`)
    } else {
      setLoading(false)
    }
  }

  const addSLA = async () => {
    setLoading(true)
    let slaId = ''
    const result: any = await addSLAAction({})
    if (result.payload.success) {
      slaId = result.payload.data._id
      navigation(`/slas/${slaId}?tab=trigger`)
    } else {
      setLoading(false)
    }
  }

  return (
    <>
      {show ? (
        <Modal
          show={true}
          onHide={() => setShow(false)}
          centered
          contentClassName='bg-white'
          size='lg'
        >
          <Modal.Header className='bg-routera-900 px-8 h-36 lg:h-28 flex justify-center items-center'>
            <div className='w-[100%] h-[100%]'>
              <Modal.Title className='fw-bold text-white pt-2  px-2 lg:px-3 text-sm lg:text-xl'>
                Choose a trigger
              </Modal.Title>
              <div className='w-[80%]'>
                <p className='text-white text-xs lg:text-sm px-2 lg:px-3 pb-4 '>
                  {description}
                </p>
              </div>
              <div className='flex justify-center items-center pt-2 pb-2'>
                <div className='lg:hidden flex justify-center border-2 border-solid border-white rounded-md'>
                  <button className='text-white pl-4 pr-2 py-2 text-sm lg:text-base '>
                    Documentation
                  </button>
                  <div className='flex justify-center text-white items-center pr-3'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      fill='none'
                      viewBox='0 0 24 24'
                      strokeWidth='1.5'
                      stroke='currentColor'
                      className='w-6 h-6'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        d='M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25'
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div className='hidden lg:flex lg:justify-end lg:border-2 lg:border-solid lg:border-white lg:rounded-md lg:mr-3'>
              <button className='text-white pl-4 pr-2 py-2 text-sm lg:text-base'>
                Documentation
              </button>
              <div className='flex justify-center text-white items-center pr-3'>
                <svg
                  xmlns='http://www.w3.org/2000/svg'
                  fill='none'
                  viewBox='0 0 24 24'
                  strokeWidth='1.5'
                  stroke='currentColor'
                  className='w-6 h-6'
                >
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    d='M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25'
                  />
                </svg>
              </div>
            </div>
          </Modal.Header>

          <Modal.Body
            className={`bg-white rounded-b-2xl p-0 ${
              loading ? 'opacity-25' : 'opacity-100'
            }`}
          >
            <div className='lg:flex justify-around h-[530px]'>
              <div className='bg-slate-50 w-[100%] lg:w-[60%] lg:p-4 rounded-lg'>
                <ListIntegrations
                  addRouter={isNewRouter ? addRouter : addSLA}
                  loading={loading}
                ></ListIntegrations>
              </div>
              <div className='lg:hidden lg:bg-white lg:shadow-xl lg:w-[100%] lg:divide-x flex lg:justify-center lg:items-center rounded-lg'>
                <div className='h-[50%] md:p-2 p-4'>
                  <div>
                    <span className='font-bold text-sm lg:text-xl'>
                      Build-in tools
                    </span>
                  </div>
                  <div>
                    <span className='text-xs lg:text-sm'>
                      Try a built in integration
                    </span>
                  </div>
                  <div className='lg:w-[270px] lg:h-[126px] opacity-25 lg:flex justify-around lg:py-4 rounded-lg'>
                    <div className='w-[50%] flex justify-center md:pt-2 pt-4'>
                      <a className='cursor-pointer'>
                        <img src={webhookIcon} alt='' />
                      </a>
                    </div>
                    <div>
                      <div className='pt-4 pb-2'>
                        <span className='font-bold text-sm lg:text-base'>
                          Webhooks
                        </span>
                      </div>
                      <div>
                        <span className='text-xs lg:text-sm'>
                          Start the router when a another app sends a webhook
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='h-[50%] p-4'>
                  <div>
                    <span className='font-bold text-sm lg:text-xl'>
                      Learn more
                    </span>
                  </div>
                  <div>
                    <span className='text-xs lg:text-sm'>
                      1 minute video on how routers work{' '}
                    </span>
                  </div>
                  <div className='flex justify-center pt-4'>
                    <button>
                      <div className='relative'>
                        <div className='absolute left-[3rem] top-5 h-8 w-8 bg-white rounded-full'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 24 24'
                            fill='currentColor'
                            className='text-blue-700 w-6 h-6 absolute left-[6px] top-[4px]'
                          >
                            <path
                              fillRule='evenodd'
                              d='M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z'
                              clipRule='evenodd'
                            />
                          </svg>
                        </div>
                      </div>
                      <img src={videoClip} alt='' />
                    </button>
                  </div>
                </div>
              </div>
              <div className='hidden lg:block lg:bg-white lg:shadow-xl lg:w-[40%] lg:divide-y rounded-lg'>
                <div className='h-[50%] p-4'>
                  <div>
                    <span className='font-bold text-xl'>Build-in tools</span>
                  </div>
                  <div>
                    <span className='text-sm'>Try a built in integration</span>
                  </div>
                  <div className='w-[270px] h-[126px] opacity-25 flex justify-around py-3'>
                    <div className='w-[50%] flex justify-center md:pt-2 pt-4'>
                      <a className='cursor-pointer'>
                        <img src={webhookIcon} alt='' />
                      </a>
                    </div>
                    <div>
                      <div className='pt-4 pb-2'>
                        <span className='font-bold text-base'>Webhooks</span>
                      </div>
                      <div>
                        <span className='text-sm'>
                          Start the router when a another app sends a webhook
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='h-[50%] p-4'>
                  <div>
                    <span className='font-bold text-xl'>Learn more</span>
                  </div>
                  <div>
                    <span className='text-sm'>
                      1 minute video on how routers work{' '}
                    </span>
                  </div>
                  <div className='flex justify-center pt-4'>
                    <button disabled={loading}>
                      <div className='relative'>
                        <div className='absolute left-[6rem] top-12 h-11 w-11 bg-white rounded-full'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 24 24'
                            fill='currentColor'
                            className='text-blue-700 w-6 h-6 absolute left-[10px] top-[10px]'
                          >
                            <path
                              fillRule='evenodd'
                              d='M4.5 5.653c0-1.427 1.529-2.33 2.779-1.643l11.54 6.347c1.295.712 1.295 2.573 0 3.286L7.28 19.99c-1.25.687-2.779-.217-2.779-1.643V5.653Z'
                              clipRule='evenodd'
                            />
                          </svg>
                        </div>
                      </div>
                      <img src={videoClip} alt='' />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          {loading && (
            <div
              role='status'
              className='absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2'
            >
              <svg
                aria-hidden='true'
                className='w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600'
                viewBox='0 0 100 101'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z'
                  fill='currentColor'
                />
                <path
                  d='M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z'
                  fill='currentFill'
                />
              </svg>
            </div>
          )}
        </Modal>
      ) : null}
    </>
  )
}

export default CreateNewRouter
